import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { generateConsolidatedPurchasesReport } from 'Services/JOONAdmin/joonAdminReportsService'

import { QueryNames } from 'Hooks/api/queryNames'

import { Employer } from 'Utils/types/JOONAdmin/employer'
import { formatDateForServer } from 'Utils/helpers/dateUtils'

export const useGenerateConsolidatedPurchasesReport = () =>
  useMutation(
    [QueryNames.GenerateConsolidatedPurchasesReport],
    async ({
      employerId,
      startDate,
      endDate,
      reportName,
      countryCode
    }: {
      employerId: Employer['id']
      startDate: Date
      endDate: Date
      reportName: string
      countryCode: string
    }) => {
      const startDateString = formatDateForServer(startDate)
      const endDateString = formatDateForServer(endDate)
      const response = await generateConsolidatedPurchasesReport(
        employerId,
        startDateString,
        endDateString,
        reportName,
        countryCode
      )
      if (response.success) {
        toast.success('Consolidated report is being generated in Google Drive')
      } else {
        toast.error(response.message || 'Failed to generate consolidated report')
      }
    },
    {
      onError: () => {
        toast.error('Failed to generate consolidated report')
        return undefined
      }
    }
  )
